<div id="header">
  <button id="login-button" class="login-button">{{ buttonText }}</button>
  
  <a [routerLink]="['/home']">
    <img height="100%" src="assets/images/logo.svg">
  </a>
</div>
